import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "./index.css"
import App from "./App.jsx"
import * as Sentry from "@sentry/react"
import { ReduxProvider } from "./store/index.jsx"

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://a46c11f43d56c3c67eadf949f53226e5@o4510656380534784.ingest.us.sentry.io/4510656965705728",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
      }),
    ],
    tracesSampleRate: 0.1,
    tracePropagationTargets: ["localhost", /^https:\/\/app\.plainsignal\.io/],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  })
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ReduxProvider>
      <App />
    </ReduxProvider>
  </StrictMode>
)
